module.exports = __webpack_public_path__ + "static/media/Section1_World.26322eb5.svg";